/**
 * Contexto de autenticação para compartilhar o estado de autenticação por toda a aplicação
 */
import React, { createContext, useContext } from 'react';
import { useAuth } from '../hooks/useAuth';

// Criar o contexto
const AuthContext = createContext(null);

/**
 * Provider do contexto de autenticação
 * @param {Object} props - Props do componente
 * @param {React.ReactNode} props.children - Componentes filhos
 */
export function AuthProvider({ children }) {
  // Usar o hook de autenticação para obter o estado e métodos
  const auth = useAuth();

  // Fornecer o estado e métodos para todos os componentes filhos
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

/**
 * Hook para acessar o contexto de autenticação
 * @returns {Object} Estado e métodos de autenticação
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useAuthContext() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext deve ser usado dentro de um AuthProvider');
  }

  return context;
}

export default AuthContext;
